<template>
  <div class="root">
    <el-tabs>
      <div class="top">
        <el-button v-for="(item,index) in btnArr" type="primary" :plain='activeIndex== item.index ?  false : true'  @click="tabBtn(item)">{{ item.name }}</el-button>
        <div class="line"></div>
      </div>
    </el-tabs>
    <div class="main">
          <bannerConfig :banner="banner" v-if="isConfig" ref="config"></bannerConfig>
    </div>
  </div>
</template>

<script>
import bannerConfig from './banner-config.vue'
import {Controller} from './banner-serve'

export default {
  components:{
    bannerConfig
  },
  data(){
    return {
      activeIndex:1,
      btnArr:[
        {
          index:1,
          name:'运维管理web'
        },
        {
          index:2,
          name:'工厂端web'
        },
        {
          index:3,
          name:'代理商web'
        },
        {
          index:4,
          name:'安装小程序'
        },
        {
          index:5,
          name:'工厂App'
        },
        {
          index:6,
          name:'代理App'
        }
      ],
      banner:{},
      isConfig:false
    }
  },
  mounted(){
     // 进入默认为运维管理的banner
      this.banner = Controller.getObject(1);
      this.getList();
  },
  methods:{
    getList(){
      this.banner.getBannerLayoutList();
      Promise.all([this.banner.getBannerLayoutList]).then(value=>{
        console.log('测试-----',this,this.$refs)
        this.isConfig = true;
        setTimeout(()=>{
          this.$refs.config.open({banner:this.banner});
        },500)
      })
    },
    tabBtn(item){
      this.activeIndex = item.index+'';
      this.banner = Controller.getObject(item.index);
      this.getList();
    }
  }
}
</script>

<style lang="scss" scoped>
  .root{
    height: 100%;
    width: 100%;
  }
  .line{
    width: 100%;
    margin-top: 12px;
    border: 1px solid rgb(222, 222, 222);
  }
  .top{
    white-space: nowrap;
    padding-left: 20px;
    padding-right: 20px;
  }
  .main{
    padding-top: 7px;
    width: 100%;
    padding-left: 20px;
    height: 90%;
    width: 100%;
    box-sizing: border-box;
    padding-right: 18px;
  }

  // ::v-deep .el-tabs__header{
  //   margin: 0;
  // }

  // ::v-deep .el-tabs .el-tabs--top{
  //   height: 100%;
  //   width: 100%;
  //   box-sizing: border-box;
  // }
</style>